import React from 'react'

const SubmenuList = (props) => {
   const { subMenuList, activeSubMenuId } = props;

   const withOutArrowId = ["alienFX", "cryotech", "frontControl", "rearControl"];
   const hasRadioButton = subMenuList.some(item => item.menuType === "radioButton");

   // --- Filter logic for Liquid Cooled submenu ---
   // Find if this submenu contains "liquidcooled"
  const hasSpecialParent = subMenuList.some(item => item.id === "liquidcooled" || item.id === "dustControl");
   let filteredSubMenuList = subMenuList;

   if (hasSpecialParent) {
   filteredSubMenuList = subMenuList.filter(item => {
      // Always show the parent items
      if (item.id === "liquidcooled" || item.id === "dustControl") return true;
      // Show children of "liquidcooled" only if active
      if (
         (item.id === "alienFX" || item.id === "cryotech") &&
         activeSubMenuId === "liquidcooled"
      ) return true;
      // Show children of "dustControl" only if active
      if (
         (item.id === "frontControl" || item.id === "rearControl") &&
         activeSubMenuId === "dustControl"
      ) return true;
      // Hide children otherwise
      if (
         item.id === "alienFX" || item.id === "cryotech" ||
         item.id === "frontControl" || item.id === "rearControl"
      ) return false;
      // Show all other items
      return true;
   });
}
   // --- End filter logic ---

   return (
      <div className='accordionContent'>
         <ul className='subMenu' aria-hidden="true" role={hasRadioButton ? "radiogroup" : undefined }>
            {
               filteredSubMenuList.map((list) => (
                     list.subMenuVisibility && (
                     <li key={list.id}
                        tabIndex={-1}
                        defaultChecked={true}
                        className={`subMenuBtn ${list.menuType}`}
                        id={`menu_id_${list.id}`}
                        aria-current="false"
                     onKeyDown={(e) => {
                        if (e.key !== 'Enter') {
                           return
                        } props.handleMenuClick(list)
                        }}
                        onClick={(event) => {
                        props.handleMenuClick(list,event)
                     }} >
                        {list.menuType === "radioButton" ? (
                        <>
                        <input type={"radio"} value={"product1"} tabIndex={-1} id={list.id} className="radioFocus" name={list.featureType} />
                        <label id="tower_tab" htmlFor={list.id}> {list.title}</label>
                       </>                      
                     ): ((window.mob || window.innerHeight > window.innerWidth) && props.orentation === 0) || window.innerWidth < 935 ?
                           <>
                               { !withOutArrowId.includes(list.id) && (
                        <div className='accordia_icon'>
                         <img className='arrow' src='images/spacer.png' id={`accordianIcon_${list.id}`} />
                              </div>
                                   )}
                              {list.title}
                              </>
                              : list.title}
                     </li>
                  )
               ))
            }
         </ul>
      </div>
   )
}

export default SubmenuList